<app-basic-card>
    <div class="d-flex justify-content-start align-items-center pt-2 pb-2">
        <h6>Dati del contraente:</h6>
    </div>
    <app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
</app-basic-card>